import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ShoppingCart, Wallet, Clock, Package, AlertTriangle, Users, ShoppingBag } from "lucide-react";
import { api, tl } from "@/lib/api";
import { PageTitle } from "@/pages/admin/AdminLayout";

export default function AdminDashboard() {
  const { data: s } = useQuery({ queryKey: ["admin-stats"], queryFn: () => api.get("/admin/stats").then((r) => r.data) });
  const cards = [
    ["Toplam Sipariş", s?.orders, ShoppingCart, "/yonetim/siparisler"],
    ["Toplam Ciro", tl(s?.revenue), Wallet, "/yonetim/siparisler"],
    ["Yeni Sipariş", s?.new_orders, Clock, "/yonetim/siparisler"],
    ["Ödeme Bekleyen", s?.pending_payments, Wallet, "/yonetim/odemeler"],
    ["Ürün", s?.products, Package, "/yonetim/urunler"],
    ["Stoğu Azalan (<10)", s?.low_stock, AlertTriangle, "/yonetim/urunler"],
    ["Üye Müşteri", s?.customers, Users, "/yonetim/musteriler"],
    ["Sepette Bekleyen", s?.abandoned_carts, ShoppingBag, "/yonetim/musteriler"],
  ];
  return (
    <>
      <PageTitle title="Yönetim Özeti" desc="Mağazanızın bugünkü durumu" />
      <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">
        {cards.map(([label, val, Icon, to]) => (
          <Link key={label} to={to} data-testid={`stat-${label}`} className="bg-white border rounded-lg p-5 hover:shadow-md transition-shadow">
            <Icon className="h-5 w-5 text-[#16A34A]" />
            <div className="text-2xl sm:text-3xl font-extrabold text-[#172554] mt-3">{val ?? "-"}</div>
            <div className="text-sm text-slate-600">{label}</div>
          </Link>
        ))}
      </div>
    </>
  );
}
